/**
 * Permission codes this app declares an interest in.
 *
 * They are dot-strings issued by the server's RBAC catalogue (CLAUDE.md §6) and
 * arrive on `/auth/me`. Naming them here rather than sprinkling literals means a
 * renamed permission is one compile error, not a silent invisible menu.
 */

export const PERMISSIONS = {
  userList: 'admin.user.list',
  userCreate: 'admin.user.create',
  userUpdate: 'admin.user.update',
  userDisable: 'admin.user.disable',
  userInvite: 'admin.user.invite',

  roleList: 'admin.role.list',
  roleCreate: 'admin.role.create',
  roleUpdate: 'admin.role.update',

  settingsRead: 'admin.settings.read',

  auditRead: 'audit.log.read',
  auditExport: 'audit.log.export',

  approvalAct: 'approval.task.act',
  approvalPolicyManage: 'approval.policy.manage',

  notificationRead: 'notification.read',

  taxCodeRead: 'tax.code.read',
  taxCodeManage: 'tax.code.manage',
  taxGroupRead: 'tax.group.read',
  taxGroupManage: 'tax.group.manage',
  taxReportRead: 'tax.report.read',
  taxReportExport: 'tax.report.export',

  fxCurrencyRead: 'fx.currency.read',
  fxCurrencyManage: 'fx.currency.manage',
  fxRateRead: 'fx.rate.read',
  fxRateManage: 'fx.rate.manage',
} as const

export type PermissionCode = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]
